import { render } from "./ResourcesView.vue?vue&type=template&id=53d2e9ff"
const script = {}

import "./ResourcesView.vue?vue&type=style&index=0&id=53d2e9ff&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__